import {
  InteractiveComponent,
  LessonComponentBase
} from '../models/LessonComponent';

import LessonComponentService from '../services/LessonComponentService';
import { LessonComponentType } from '../models/LessonComponentType';

export interface Question {
  componentkey: number;
  questionType: LessonComponentType;
}

const useUnansweredQuestions = () => {
  const getUnanswered = (
    components: LessonComponentBase[],
    editComponents: LessonComponentBase[]
  ) => {
    //Check if there is any unanswered questions components
    const unansweredComponents: InteractiveComponent[] = components.filter(
      (c) => {
        return editComponents.find(
          (e) =>
            e.componentkey === c.componentkey &&
            LessonComponentService.isInteractive(e) &&
            !e.answer &&
            !c.answer
        );
      }
    );
    //Get the unanswered questions and componentkey
    const unanswered: Question[] = unansweredComponents.map((item) => {
      return {
        componentkey: item.componentkey,
        questionType: item.type
      };
    });
    //Check if there is any unsaved components(only for interactive components)
    const unsavedComponents: InteractiveComponent[] = components.filter((c) => {
      const updated = editComponents.find(
        (e) =>
          e.componentkey === c.componentkey && e.answer && e.answer !== c.answer
      );
      return updated;
    });

    //Get the questions and componentkey where the answers are not saved
    const unsaved: Question[] = unsavedComponents.map((item) => {
      return {
        componentkey: item.componentkey,
        questionType: item.type
      };
    });

    return { unanswered, unsaved };
  };

  return {
    getUnanswered
  };
};

export default useUnansweredQuestions;
